import { t } from 'i18next';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { CourseBanner } from '@/components/custom/course';
import { Badge } from '@/components/ui/badge';
import { BulletinBoardContainer, BulletinBoardItem, BulletinBoardTitle } from '@/components/custom/bulletin-board';

export function BulletinBoardsModal({ banner, open, onClose }) {
  const navigate = useNavigate();

  return (
    <Dialog
      open={open}
      onOpenChange={onClose}
    >
      <DialogContent size="lg">
        <DialogTitle className="text-primary">Banner informativo</DialogTitle>
        <DialogDescription className="sr-only">Visualização do banner</DialogDescription>

        <CourseBanner
          backgroundUrl={banner?.image?.url}
          alt="Banner"
          className="min-h-[252px]"
        />

        <BulletinBoardContainer>
          <BulletinBoardItem>
            <BulletinBoardTitle>Título</BulletinBoardTitle>
            <div>{banner?.title}</div>
          </BulletinBoardItem>

          <BulletinBoardItem>
            <BulletinBoardTitle>Perfis associados</BulletinBoardTitle>
            <div>{banner?.profiles?.map(profile => profile.name).join(', ')}</div>
          </BulletinBoardItem>

          <BulletinBoardItem>
            <BulletinBoardTitle>Status</BulletinBoardTitle>
            <div>
              <Badge
                variant={banner?.['published-at'] ? 'success' : 'warning'}
                size="xs"
              >
                {banner?.['published-at'] ? 'Publicado' : 'Não publicado'}
              </Badge>
            </div>
          </BulletinBoardItem>

          <BulletinBoardItem>
            <BulletinBoardTitle>Período</BulletinBoardTitle>
            <div>
              {moment(banner?.['start-date']).format('DD/MM/YYYY')} - {moment(banner?.['end-date']).format('DD/MM/YYYY')}
            </div>
          </BulletinBoardItem>

          <BulletinBoardItem>
            <BulletinBoardTitle>Link</BulletinBoardTitle>
            <div className="underline">{banner?.link || '-'}</div>
          </BulletinBoardItem>

          <BulletinBoardItem>
            <BulletinBoardTitle>Texto do botão</BulletinBoardTitle>
            <div>{banner?.label || '-'}</div>
          </BulletinBoardItem>
        </BulletinBoardContainer>

        <Button
          variant="outline"
          wide
          onClick={() => navigate(`/banners/novo/${banner.id}`)}
          className="ml-auto"
        >
          {t('button.edit')}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
